import React, {useState} from 'react';
import {Input, Label, RadioButton, RadioButtonList, SimpleButton} from "@tag/tag-components-react-v4";
import ConfirmDetails from "./ConfirmDetails";
import {EnvironmentTemplate} from "../types/EnvironmentTemplate";
import CountryService from "../services/CountryService";
import CustomerService from "../services/CustomerService";
import styles from './EnterDetails.module.scss'
import { ProjectAccents } from "../../General/config/projectAccents";

function EnterDetails(props: {createEnvironmentFn: Function, chosenTemplate: EnvironmentTemplate, environmentName?: string}) {
    const [customerName, setCustomerName] = useState('');
    const [displayedCustomerName, setDisplayedCustomerName] = useState('');
    const [locationId, setLocationId] = useState<number>(0);
    const [confirmationModalVisible, setConfirmationModalVisible] = useState(false);
    
    const handleCreateButton = () => {
        setConfirmationModalVisible(true)
    }
    
    const renderCountryOptions = () => {
        const radioButtons = CountryService.getCountryOptions().map(c =>
            <RadioButton value={c.id} heading={c.display}>{c.currency} ({c.currencyCode})</RadioButton>
        );
        
        return (
            <RadioButtonList
                name="radioBtn"
                onChange={e => setLocationId(e.target.value)}
            >
                {radioButtons}
            </RadioButtonList>
        );
    }
    
    const handleCustomerNameChange = (name: string) => {
        setCustomerName(name);
        setDisplayedCustomerName(name);
    }

    const handleCustomerNameBlur = () => {
        const cleanedName = customerName.trim().replace(/  +/g, ' ');
        setCustomerName(cleanedName);
        setDisplayedCustomerName(
            CustomerService.getCustomerNameFromCustomerNamingConvention(props.chosenTemplate.companyNamingConvention, cleanedName)
        );
    }

    return (
        <>
            <div className={styles.CreateEnvironmentEnterDetailsContainer}>
                <div className={styles.CreateEnvironmentEnterDetailsElement}>
                    <Input
                        style={{width: '20em'}}
                        placeholder="Enter Customer Name"
                        onChange={(e) => handleCustomerNameChange(e.target.value)}
                        value={displayedCustomerName}
                        onBlur={() => handleCustomerNameBlur()}
                        onFocus={() => setDisplayedCustomerName(customerName)}
                    />
                </div>
                <div className={styles.CreateEnvironmentEnterDetailsElement}>
                    <Label>Select Location</Label>
                </div>
                <div className={styles.CreateEnvironmentEnterDetailsElement}>
                    {renderCountryOptions()}
                </div>
                <div className={styles.CreateEnvironmentEnterDetailsElement}>
                    <SimpleButton
                        accent={ProjectAccents.PeoplePlanner}
                        disabled={!customerName || !locationId}
                        onClick={() => handleCreateButton()}
                    >
                        Create Environment
                    </SimpleButton>
                </div>
            </div>
            <ConfirmDetails
                visible={confirmationModalVisible}
                setVisible={setConfirmationModalVisible}
                createEnvironmentFn={props.createEnvironmentFn}
                chosenTemplate={props.chosenTemplate}
                customerName={customerName}
                locationId={locationId}
                environmentName={props.environmentName}
            />
        </>
    );
}

export default EnterDetails;
